import { render, staticRenderFns } from "./AssignedToYou.vue?vue&type=template&id=b4aa0b6c&"
import script from "./AssignedToYou.vue?vue&type=script&lang=ts&"
export * from "./AssignedToYou.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports